const aggregateStats = [
  { value: '312%', label: 'Average lead increase in first 90 days' },
  { value: '97%', label: 'Client retention rate after year one' },
  { value: '4.9★', label: 'Average satisfaction rating' },
  { value: '500+', label: 'USA businesses served' },
];

const testimonials = [
  {
    stars: 5,
    quote: "We were invisible online before working with 99 Marketing. Within 90 days, we jumped to page one on Google, started showing up in AI search results, and our phone started ringing consistently. The new website looks incredible and converts like crazy. Best investment we've made.",
    name: 'Marcus T.',
    title: 'Owner, Premier Roofing Solutions',
    location: 'Dallas, TX',
    initials: 'MT',
    result: '+400% leads in 90 days',
    color: 'from-emerald-400 to-teal-400',
  },
  {
    stars: 5,
    quote: "I was skeptical about paying monthly, but the $0 upfront deal made it easy to try. Three months in — my website traffic doubled, my local map listing is top 3, and I'm getting leads from voice searches I never even thought about. The team is responsive and proactive.",
    name: 'Jennifer K.',
    title: 'Owner, Bright Smile Dental Care',
    location: 'Austin, TX',
    result: '#1 on Google Maps locally',
    initials: 'JK',
    color: 'from-teal-400 to-emerald-300',
  },
  {
    stars: 5,
    quote: "What separates 99 Marketing is they built a system, not just a website. My contractor business went from 2-3 leads a week to 15-20. The new site is modern, fast, and our customers constantly compliment how professional it looks. Game changer.",
    name: 'David R.',
    title: 'Owner, RapidBuild Contractors',
    location: 'Phoenix, AZ',
    result: '15–20 leads/week from 2–3',
    initials: 'DR',
    color: 'from-emerald-500 to-teal-400',
  },
];

export default function TestimonialsSection() {
  return (
    <section id="testimonials" className="bg-white py-24 md:py-32">
      <div className="max-w-6xl mx-auto px-4 md:px-8">

        {/* Aggregate results bar */}
        <div className="bg-gradient-to-r from-[#0d1117] to-[#0a1f1a] rounded-2xl px-7 md:px-12 py-7 mb-16">
          <p className="text-white/35 text-xs font-bold uppercase tracking-widest text-center mb-6">Aggregate Results Across 500+ Clients</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4">
            {aggregateStats.map((s) => (
              <div key={s.label} className="text-center">
                <p className="text-3xl md:text-4xl font-black bg-gradient-to-r from-emerald-400 to-teal-300 bg-clip-text text-transparent mb-1 leading-none">{s.value}</p>
                <p className="text-white/40 text-xs leading-snug">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Section header */}
        <div className="text-center mb-12">
          <p className="text-emerald-500 text-xs font-bold tracking-widest uppercase mb-4">Client Results</p>
          <h2 className="text-3xl md:text-5xl font-black text-[#0d1117] leading-tight mb-4">
            Real Businesses. Real Growth.
          </h2>
          <p className="text-[#6b7280] text-base md:text-lg">What happens when your website actually works for you.</p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="relative bg-white border border-[#e5e7eb] rounded-2xl p-7 md:p-8 flex flex-col hover:border-emerald-200 hover:shadow-lg transition-all duration-300 group"
            >
              {/* Result badge */}
              <div className="inline-flex items-center gap-1.5 bg-emerald-50 border border-emerald-100 rounded-full px-3 py-1 mb-5 self-start">
                <i className="ri-arrow-up-line text-emerald-500" style={{ fontSize: '12px' }}></i>
                <span className="text-emerald-700 text-xs font-bold">{t.result}</span>
              </div>

              {/* Stars */}
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400" style={{ fontSize: '14px' }}></i>
                ))}
              </div>

              {/* Quote mark */}
              <i className="ri-double-quotes-l text-emerald-50 absolute top-6 right-7" style={{ fontSize: '44px' }}></i>

              {/* Quote */}
              <p className="text-[#374151] text-sm md:text-base leading-relaxed flex-1 mb-7 relative z-10">
                &ldquo;{t.quote}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className={`w-11 h-11 rounded-full bg-gradient-to-br ${t.color} flex items-center justify-center flex-shrink-0`}>
                  <span className="text-white text-sm font-bold">{t.initials}</span>
                </div>
                <div>
                  <p className="text-[#0d1117] font-bold text-sm">{t.name}</p>
                  <p className="text-[#9ca3af] text-xs">{t.title}</p>
                  <p className="text-[#9ca3af] text-xs">{t.location}</p>
                </div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-emerald-400 to-teal-400 rounded-b-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
